import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios, { AxiosResponse } from "axios";
import request from "@util/net/request";
import { executeOnceAtATime } from "@util/net/index";
import {
  FavoritesStylingActions,
  GET_FAVORITES_STYLING,
  POST_FAVORITES_STYLING,
  DELETE_FAVORITES_STYLING,
  ConfigActions
} from "@redux/reducer";
import {
  DelFavoritesStylingPayload,
  FavoritesStylingDataType,
  FavoritesStylingPayload,
  FavoritesStylingResponse,
  OperateFavoritesResponse,
  PostFavoritesStylingPayload
} from "@type/index";

// get favorites styling list
export function* getFavoritesStylingSaga(action: {
  payload: FavoritesStylingPayload;
}) {
  try {
    const payload: FavoritesStylingPayload = action.payload;
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(true));
    const res: AxiosResponse<FavoritesStylingResponse> = yield call(
      request.get,
      "/favorites/styles/search",
      {
        params: {
          ids: payload.ids
        }
      }
    );
    const _res: FavoritesStylingDataType = {
      list: res.data.result,
      type: payload.type || "sb"
    };
    yield put(FavoritesStylingActions.getFavoritesStylingSuccess(_res));
  } catch (error) {
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(false));
  }
}

// add favorites styling
export function* postFavoritesStylingSaga(action: {
  payload: PostFavoritesStylingPayload;
}) {
  try {
    const payload: PostFavoritesStylingPayload = action.payload;
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(true));
    const res: AxiosResponse<OperateFavoritesResponse> = yield call(
      request.post,
      "/favorites/styles",
      payload
    );
    if (res.data.status === "ok") {
      yield put(
        FavoritesStylingActions.postFavoritesStylingSuccess({
          id: payload.body[0].styleId,
          type: payload.type || "sb"
        })
      );
    }
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(false));
  } catch (error) {
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(false));
    if (!axios.isCancel(error)) {
      yield put(ConfigActions.setShowWishIconError(true));
    }
  }
}

// del favorites styling
export function* deleteFavoritesStylingSaga(action: {
  payload: DelFavoritesStylingPayload;
}) {
  try {
    const payload: DelFavoritesStylingPayload = action.payload;
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(true));
    const res: AxiosResponse<OperateFavoritesResponse> = yield call(
      request.del,
      `/favorites/styles/${payload.styleId}`
    );
    if (res.data.status === "ok") {
      yield put(
        FavoritesStylingActions.delFavoritesStylingSuccess({
          id: payload.styleId,
          type: payload.type || "sb"
        })
      );
    }
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(false));
  } catch (error) {
    yield put(FavoritesStylingActions.getFavoritesStylingLoading(false));
    if (!axios.isCancel(error)) {
      yield put(ConfigActions.setShowWishIconError(true));
    }
  }
}

export const addWishlistStylingBookStyling = executeOnceAtATime(
  postFavoritesStylingSaga
);
export const delWishlistStylingBookStyling = executeOnceAtATime(
  deleteFavoritesStylingSaga
);

export function* watchLoadFavoritesStylingSaga() {
  yield takeEvery<any>(GET_FAVORITES_STYLING, getFavoritesStylingSaga);
  yield takeLatest<any>(POST_FAVORITES_STYLING, addWishlistStylingBookStyling);
  yield takeLatest<any>(
    DELETE_FAVORITES_STYLING,
    delWishlistStylingBookStyling
  );
}
